<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable fullscreen>
      <v-card>
        <v-card-title dark class="dialog-header pt-2 pb-2 pl-6">
          <span>Employee Leave Card ({{ name }})</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 900px" class="my-4">
          <v-container>
            <v-row>
              <v-col cols="12" md="8" class="flex-items">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @click="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col>
              <!-- <v-col cols="6"
                ><div class="d-flex">
                  <div style="width:20%" class="text-subtitle-1">Name:</div>

                  <div style="width:80%" class="text-subtitle-1">
                    {{ name }}
                  </div>
                </div>
              </v-col> -->
              <v-col cols="12" style=" margin-top: -40px;" v-if="tab == 1">
                <table class="table mt-5 mx-2">
                  <thead>
                    <tr>
                      <th
                        align="center"
                        class="text-caption px-4 font-weight-bold py-2"
                        rowspan="2"
                        colspan="2"
                      >
                        Period
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                        colspan="2"
                      >
                        Particulars
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                        colspan="4"
                      >
                        Vacation Leave
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                        colspan="4"
                      >
                        Sick Leave
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                        rowspan="2"
                      >
                        Total
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                        rowspan="2"
                      >
                        Date Filed
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-2"
                        rowspan="2"
                      >
                        Remarks
                      </th>
                      <th
                        v-if="toEdit"
                        align="center"
                        class="text-caption font-weight-bold py-2"
                        rowspan="2"
                      >
                        Action
                      </th>
                    </tr>
                    <tr>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-1"
                      >
                        Type
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-1"
                      >
                        Days
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-1"
                      >
                        Earned
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-1"
                      >
                        Abs.<br />
                        W/P
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-1"
                      >
                        Bal.
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-1"
                      >
                        Abs.<br />
                        W/OP
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-1"
                      >
                        Earned
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-1"
                      >
                        Abs.<br />
                        W/P
                      </th>
                      <th
                        align="center"
                        class="text-caption font-weight-bold py-1"
                      >
                        Bal.
                      </th>

                      <th
                        align="center"
                        class="text-caption font-weight-bold py-1"
                      >
                        Abs.<br />
                        W/OP
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in leave_card_data" :key="i">
                      <td align="left" class="text-caption pa-2 ">
                        {{ item.period_earned }}
                      </td>
                      <td align="center" class="text-caption pa-2 ">
                        {{ item.period }}
                      </td>
                      <td
                        :colspan="item.type == 'Balance Forwarded' ? 2 : 1"
                        align="center"
                        class="text-caption py-2"
                      >
                        {{ item.type }}
                      </td>
                      <td
                        v-if="item.type != 'Balance Forwarded'"
                        align="center"
                        class="text-caption py-2"
                      >
                        {{ item.days }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{
                          item.vl_earned
                            ? formatNumberValue(item.vl_earned, 3)
                            : item.vl_earned
                        }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{ item.vl_auwp }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{
                          item.vl_bal
                            ? formatNumberValue(item.vl_bal, 3)
                            : item.vl_bal
                        }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{ item.vl_auwop }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{
                          item.sl_earned
                            ? formatNumberValue(item.sl_earned, 3)
                            : item.sl_earned
                        }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{ item.sl_auwp }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{
                          item.sl_bal
                            ? formatNumberValue(item.sl_bal, 3)
                            : item.sl_bal
                        }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{ item.sl_auwop }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{
                          item.total
                            ? formatNumberValue(item.total, 3)
                            : item.total
                        }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        {{ item.date_filed ? formatDate(item.date_filed) : "" }}
                      </td>
                      <td align="center" class="text-caption py-2">
                        <div style="width:100px" class="text-wrap text-justify">
                          {{ item.remarks }}
                        </div>
                      </td>
                      <td
                        v-if="toEdit"
                        align="center"
                        class="text-caption py-2"
                      >
                        <div
                          v-if="item.leave_id"
                          style="width:100px"
                          class="text-wrap text-justify"
                        >
                          <v-btn
                            x-small
                            class="white--text"
                            @click="confirmRestore(item.leave_id)"
                            color="#6DB249"
                          >
                            restore
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
              <v-col cols="12" v-if="tab == 2" style=" margin-top: -20px;">
                <v-data-table
                  :headers="headers"
                  :items="itemsData"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.date_restored`]="{ item }">
                    {{ formatDate(item.date_restored) }}
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                    <div class="text-no-wrap">
                      <v-btn
                        x-small
                        color="green"
                        class="mx-1"
                        outlined
                        @click="View(item)"
                      >
                        <v-icon size="14">mdi-eye</v-icon>
                        View
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions class="pa-5" v-if="viewFrom != 'audit'">
          <v-btn
            class="white--text"
            @click="printCard()"
            :loading="printLoading"
            :disabled="printLoading"
            color="#6DB249"
            v-if="tab == 1"
          >
            Print
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            class="white--text"
            v-if="!toEdit"
            @click="toEdit = !toEdit"
            color="#6DB249"
            v-show="tab == 1"
          >
            Edit
          </v-btn>

          <v-btn v-if="!toEdit" color="red" outlined @click="closeD()">
            Close
          </v-btn>

          <v-btn v-if="toEdit" color="red" outlined @click="toEdit = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- confirmation -->
    <v-dialog v-model="confirmDialog" persistent max-width="400">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>

          <!-- error message-->
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to restore this leave credits?
            </p>
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="confirmDialog = false">
            Close
          </v-btn>

          <!-- <v-btn
            color="green"
            class="white--text"
            :loading="submitBtnLoading"
            :disabled="submitBtnLoading"
            @click="
              parseFloat(no_days_applied) > 1 ? loadLeaveData() : restore()
            "
          >
            Yes
          </v-btn> -->
          <v-btn
            color="green"
            class="white--text"
            :loading="submitBtnLoading"
            :disabled="submitBtnLoading"
            @click="loadLeaveData()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="leaveDialog"
      eager
      persistent
      scrollable
      max-width="1000"
    >
      <v-form
        ref="RestoreFormref"
        enctype="multipart/form-data"
        @submit.prevent
      >
        <v-card>
          <v-card-title dark class="dialog-header pt-2 pb-2 pl-6">
            <span>Filed Leave Application</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="leaveDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="max-height: 900px" class="my-4">
            <v-container>
              <v-row>
                <v-col cols="12" class="mt-4">
                  <v-autocomplete
                    label="Types of Leave Availed"
                    v-model="selected_type_of_leave"
                    dense
                    readonly
                    outlined
                    class="rounded-lg"
                    :item-text="getItemText"
                    item-value="id"
                    color="#93CB5B"
                    :items="type_of_leave_list"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    selected_details_of_leave != 3 &&
                      selected_type_of_leave != 14
                  "
                >
                  <v-menu
                    ref="incDateTo"
                    :close-on-content-click="false"
                    :return-value.sync="inclusive_dates"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        color="#6DB249"
                        dense
                        v-model="getFormattedDates"
                        :rules="[formRules.required]"
                        chips
                        small-chips
                        label="Inclusive Dates"
                        :readonly="
                          parseFloat(no_days_applied) <= 1 ? true : false
                        "
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="inclusive_dates"
                      :readonly="
                        parseFloat(no_days_applied) <= 1 ? true : false
                      "
                      no-title
                      multiple
                      :min="inclusive_date_from"
                      :max="inclusive_date_to"
                      scrollable
                      :allowed-dates="isAllowedDate"
                      color="#6DB249"
                    >
                      <v-spacer></v-spacer>

                      <v-btn
                        text
                        color="#6DB249"
                        @click="
                          $refs.incDateTo.save(inclusive_dates);
                          parseFloat(no_days_applied) > 1
                            ? getCreditsToRestore()
                            : '';
                        "
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  :cols="workingDays > 0 ? 6 : 12"
                  v-if="selected_details_of_leave != 3"
                >
                  <v-text-field
                    type="number"
                    v-model="no_days_applied"
                    dense
                    outlined
                    readonly
                    label="Number of Working Days Applied"
                    color="#93CB5B"
                  ></v-text-field>
                </v-col>

                <v-col cols="6" v-if="workingDays > 0">
                  <v-text-field
                    type="number"
                    v-model="workingDays"
                    dense
                    outlined
                    readonly
                    label="Previously Restored Days"
                    color="#93CB5B"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    type="number"
                    readonly
                    :rules="[
                      formRules.required,
                      (v) =>
                        parseFloat(v) <= parseFloat(no_days_applied) ||
                        'Value should not exceed the number of days applied!',
                    ]"
                    v-model="credits_to_restore"
                    dense
                    outlined
                    required
                    label="Number of Credits to Restore"
                    color="#93CB5B"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    outlined
                    accept="application/pdf"
                    v-model="restoredFile"
                    label="File Attachment"
                    :rule="[formRules.required]"
                    dense
                  ></v-file-input>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    :rules="[formRules.required]"
                    v-model="remarks"
                    dense
                    outlined
                    required
                    label="Remarks"
                    color="#93CB5B"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-8 py-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="leaveDialog = false">
              Close
            </v-btn>

            <v-btn
              color="green"
              class="white--text"
              :loading="submitBtnLoading"
              :disabled="submitBtnLoading"
              @click="apply()"
            >
              apply
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!--Restored Dialog-->
    <v-dialog
      v-model="restoredDialog"
      eager
      persistent
      scrollable
      max-width="1000"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-2 pb-2 pl-6">
          <span>Restored Leave Credits</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeRestoreDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 900px" class="my-4">
          <v-container>
            <v-row>
              <v-col cols="12" class="mt-4">
                <v-autocomplete
                  label="Types of Leave Availed"
                  v-model="restored_selected_type_of_leave"
                  dense
                  readonly
                  outlined
                  class="rounded-lg"
                  :item-text="getItemText"
                  item-value="id"
                  color="#93CB5B"
                  :items="type_of_leave_list"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-menu
                  ref="inclusiveDate"
                  :close-on-content-click="false"
                  :return-value.sync="inclusive_dates"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      color="#6DB249"
                      dense
                      v-model="getRestoredFormattedDates"
                      :rules="[formRules.required]"
                      chips
                      :value="getRestoredFormattedDates"
                      small-chips
                      label="Inclusive Dates"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="inclusive_dates"
                    readonly
                    v-if="credits_to_restore != 1 ? true : false"
                    no-title
                    multiple
                    :allowed-dates="isAllowedDateRestored"
                    scrollable
                    color="#6DB249"
                  >
                    <v-spacer></v-spacer>

                    <v-btn
                      text
                      color="#6DB249"
                      @click="$refs.inclusiveDate.save(inclusive_dates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  type="number"
                  readonly
                  :rules="[formRules.required]"
                  v-model="credits_to_restore"
                  dense
                  outlined
                  required
                  label="Number of Credits Restored"
                  color="#93CB5B"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-btn
                  @click="getRestoredFile()"
                  block
                  color="green"
                  class="white--text mx-1 px-6"
                  elevation="2"
                >
                  View Attached File
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  :rules="[formRules.required]"
                  v-model="remarks"
                  dense
                  readonly
                  outlined
                  required
                  label="Remarks"
                  color="#93CB5B"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-8 py-4">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="closeRestoreDialog()">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <RestoredFileToVIewDialog :data="fileToView" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    action: null,
    viewFrom: null,
  },
  components: {
    RestoredFileToVIewDialog: () =>
      import("../Views/RestoredFileToVIewDialog.vue"),
  },
  data() {
    return {
      dialog: false,
      restoredDialog: false,
      leaveDialog: false,
      restored_selected_type_of_leave: null,
      itemsData: [],
      leave: null,
      type_of_leave_list: [],
      remarks: null,
      selected_type_of_leave: null,
      selected_details_of_leave: null,
      no_days_applied: null,
      credits_to_restore: null,
      inclusive_date_from: null,
      inclusive_dates: [],
      inclusive_dates_updated: [],
      inclusive_date_to: null,
      submitBtnLoading: false,
      printLoading: false,
      confirmDialog: false,
      itemToRestore: null,
      id: null,
      options: {},
      empID: null,
      name: null,
      filter: null,
      toEdit: false,
      actual_days_restore: null,
      DateRestored: null,
      restoredFile: null,
      fileToView: null,
      filename: null,
      activeTab: { id: 1, name: "Leave Credits" },
      tab: 1,
      tabList: [
        { id: 1, name: "Leave Credits" },
        { id: 2, name: "Restored" },
      ],
      headers: [
        {
          text: "Restored By",
          value: "name",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Credit Type",
          value: "credit_type",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Date Restored",
          value: "date_restored",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Action",
          value: "action",
          align: "end",
          valign: "center",
          sortable: false,
        },
      ],
      leave_card_data: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },

  watch: {
    data: {
      handler(data) {
        this.initialize(this.tab);
        this.dialog = true;
        this.toEdit = false;
        console.log(data);
        this.name = data.name;
        this.empID = data.empID;
        this.filter = this.$store.getters.getFilterSelected;
        this.loadEmployeeLeaveCard();
      },
      deep: true,
    },
  },

  computed: {
    getFormattedDates() {
      let dates = [];
      for (let i = 0; i < this.inclusive_dates.length; i++) {
        dates.push(" " + this.formatDate(this.inclusive_dates[i]));
      }
      return dates;
    },

    getRestoredFormattedDates() {
      let dates = [];
      for (let i = 0; i < this.inclusive_dates.length; i++) {
        dates.push(" " + this.formatDate(this.inclusive_dates[i]));
      }
      return dates;
    },
    workingDays() {
      try {
        const restored = this.DateRestored;
        if (restored) {
          return this.DateRestored.length;
        }
      } catch (e) {
        // Invalid JSON, fallback
      }
      return 0;
    },
  },

  methods: {
    changeTab(tab) {
      this.activeTab = tab;
      this.initialize(tab.id);
      this.tab = tab.id;
    },
    View(item) {
      console.log("Leave", item);
      this.restoredDialog = true;
      this.restored_selected_type_of_leave = item.selected_type_of_leave;
      this.remarks = item.remarks;
      this.filename = item.filename;
      // let arr = JSON.parse(item.dates_restored);
      // this.inclusive_dates = this.populateDates(arr[0], arr[arr.length - 1]);

      let arr = [];
      try {
        arr = JSON.parse(item.dates_restored);
      } catch (e) {
        console.error("Invalid JSON in item.dates_restored:", e);
      }
      this.inclusive_dates = JSON.parse(item.dates_restored);
      // if (arr.length) {
      //   this.inclusive_dates = this.populateDates(arr[0], arr[arr.length - 1]);
      //   this.credits_to_restore = arr.length;
      // } else {
      //   this.inclusive_dates = [];
      //   this.credits_to_restore = 0;
      // }
      this.credits_to_restore = arr.length;
      // this.inclusive_date_from = item.inclusive_date_from;
      // this.inclusive_date_to = item.inclusive_date_to;

      // this.inclusive_dates = this.populateDates(
      //   item.inclusive_date_from,
      //   item.inclusive_date_to
      // );

      // if (this.inclusive_dates.length > 1) {
      //   for (let i = 0; i < arr.length; i++) {
      //     this.inclusive_dates = this.inclusive_dates.filter(
      //       (item) => item !== arr[i]
      //     );
      //   }
      // }

      console.log("View Data", this.inclusive_dates);
    },
    initialize(tab) {
      if (tab == 2) {
        this.getTypeOfLeaves();
        this.axiosCall(
          "/leave-credits/getRestoredLeaveCredits/" + this.empID,
          "GET"
        ).then((res) => {
          if (res) {
            console.log(res.data);
            this.itemsData = res.data;
          }
        });
      }
    },
    isAllowedDate(date) {
      return this.inclusive_dates_updated.includes(date);
      // return this.inclusive_dates.includes(date);
    },
    isAllowedDateRestored(date) {
      // return this.inclusive_dates_updated.includes(date);
      return this.inclusive_dates.includes(date);
    },

    computeAnnual(value) {
      var annual = 0;
      for (let index = 0; index < 12; index++) {
        annual += parseFloat(value);
      }
      return annual;
    },

    loadEmployeeLeaveCard() {
      this.axiosCall(
        "/leave-credits/getLeaveCardByEmpID/" + this.empID + "/" + this.filter,
        "GET"
      ).then((res) => {
        if (res) {
          console.log(res.data);
          this.leave_card_data = res.data;
        }
      });
    },

    getItemText(item) {
      if (item.subdescription) {
        return `${item.description}  (${item.subdescription})`;
      }
      return `${item.description} `;
    },

    confirmRestore(leaveID) {
      this.itemToRestore = leaveID;
      this.axiosCall("/leave-credits/getRestored/" + leaveID, "GET").then(
        (res) => {
          if (res) {
            this.DateRestored = res.data;
            // console.log(
            //   "Dates restored",
            //   JSON.parse(this.DateRestored[0].restored_Dates)
            // );

            this.axiosCall("/leaves/" + this.itemToRestore, "GET").then(
              (res) => {
                if (res) {
                  this.leave = res.data;
                  this.selected_type_of_leave = res.data.type_of_leave_ID;
                  this.selected_details_of_leave =
                    res.data.selected_details_of_leave;
                  this.no_days_applied = res.data.no_days_applied;

                  this.inclusive_date_from = res.data.inclusive_date_from;
                  this.inclusive_date_to = res.data.inclusive_date_to;
                  this.inclusive_dates = this.populateDates(
                    res.data.inclusive_date_from,
                    res.data.inclusive_date_to
                  );
                  this.inclusive_dates_updated = this.populateDates(
                    res.data.inclusive_date_from,
                    res.data.inclusive_date_to
                  );

                  let arr = this.DateRestored;
                  // console.log("Love", arr);
                  if (arr != null) {
                    // this.actual_days_restore = res.data.no_days_applied;
                    // this.no_days_applied = this.no_days_applied - arr.length;
                    if (this.inclusive_dates.length > 1) {
                      for (let i = 0; i < arr.length; i++) {
                        this.inclusive_dates = this.inclusive_dates.filter(
                          (item) => item !== arr[i]
                        );
                      }
                    }

                    if (this.inclusive_dates_updated.length > 1) {
                      for (let i = 0; i < arr.length; i++) {
                        this.inclusive_dates_updated = this.inclusive_dates_updated.filter(
                          (item) => item !== arr[i]
                        );
                      }
                    }
                  }
                  // console.log("LOve 2", this.inclusive_dates);
                  // console.log(
                  //   "inclusive_date_from",
                  //   res.data.inclusive_date_from
                  // );
                  // console.log("inclusive_date_to", res.data.inclusive_date_to);
                  this.confirmDialog = true;
                }
              }
            );
          }
        }
      );
    },

    populateDates(from, to) {
      const startDate = new Date(from);
      const endDate = new Date(to);

      const allDates = [];
      for (
        let date = startDate;
        date <= endDate;
        date.setDate(date.getDate() + 1)
      ) {
        const dateString = date.toISOString().split("T")[0];

        allDates.push(dateString);
      }
      return allDates;
    },

    getCreditsToRestore() {
      const restored = this.DateRestored;
      if (restored) {
        let inc_dates_cnt = this.inclusive_dates.length;
        this.credits_to_restore =
          this.no_days_applied - restored.length - inc_dates_cnt;
      } else {
        let inc_dates_cnt = this.inclusive_dates.length;
        this.credits_to_restore = this.no_days_applied - inc_dates_cnt;
      }
    },

    printCard() {
      let url =
        process.env.VUE_APP_SERVER +
        "/pdf-generator/generateleaveCard/" +
        this.empID +
        "/All";

      let token = localStorage.getItem("token");
      const tabs = window.open("about:blank");
      this.printLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } }) // FETCH BLOB FROM IT
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tabs.location = _url;

          this.printLoading = false; // window.open + focus
          tabs.focus();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRestoredFile() {
      // let datastring = this.applicationletter.substring(7, 0);
      // console.log("Substring", datastring);
      // if (datastring == "default") {
      //   this.fadeAwayMessage.show = true;
      //   this.fadeAwayMessage.type = "info";
      //   this.fadeAwayMessage.header = "System Message";
      //   this.fadeAwayMessage.message =
      //     "No file Uploaded, This file is not required";
      // } else {
      let data = null;
      setTimeout(() => {
        data = null;
      }, 100);
      data = {
        filedesc: "Rerstored File",
        filename: this.filename,
      };
      this.fileToView = data;
      // }
    },

    restore() {
      this.axiosCall("/leaves/restore-credit", "POST", {
        leaveID: this.itemToRestore,
        restoreType: 1,
      }).then((res) => {
        if (res) {
          this.confirmDialog = false;
          this.itemToRestore = null;
          this.toEdit = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.loadEmployeeLeaveCard();
        }
      });
    },

    apply() {
      console.log("Love 1", this.inclusive_dates);
      console.log("L:oe re3", this.inclusive_dates_updated);
      if (this.$refs.RestoreFormref.validate()) {
        if (this.restoredFile == null) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message =
            "Please upload file attachment to restore leave credit!";
        }
        let file = this.restoredFile.name.split(".")[
          this.restoredFile.name.split(".").length - 1
        ];
        const fd = new FormData();

        if (file !== "pdf") {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Please upload file in pdf format!";
        } else {
          let dates = this.inclusive_dates_updated;

          this.inclusive_dates.sort(function(a, b) {
            let dateA = new Date(a);
            let dateB = new Date(b);

            return dateA - dateB;
          });

          let dateRemoved = dates.filter(
            (x) => !this.inclusive_dates.includes(x)
          );
          fd.append("file", this.restoredFile);
          let data = {
            leaveID: this.itemToRestore,
            restoreType: 2,
            dates_to_restore:
              parseFloat(this.no_days_applied) <= 1
                ? JSON.stringify([this.inclusive_date_from])
                : JSON.stringify(dateRemoved),
            inclusive_date_from: this.inclusive_dates[0],
            inclusive_date_to: this.inclusive_dates[
              this.inclusive_dates.length - 1
            ],
            remarks: this.remarks,
            credits_to_restore: this.credits_to_restore,
          };
          fd.append("body", JSON.stringify(data));
          // console.log(fd);
          // console.log(data);
          // console.log("Day applied", dateRemoved);

          // console.log(parseFloat(this.no_days_applied) <= 1 ? 1 : 2);
          // console.log("dates", dates, dateRemoved);
          this.axiosCall("/leaves/restore-credit", "POST", fd).then((res) => {
            if (res) {
              this.confirmDialog = false;
              this.itemToRestore = null;
              this.toEdit = false;
              this.restoredFile = null;
              this.remarks = null;
              this.leaveDialog = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.loadEmployeeLeaveCard();
            }
          });
        }
      }
    },

    loadLeaveData() {
      this.getTypeOfLeaves();
      this.credits_to_restore =
        parseFloat(this.no_days_applied) <= 1 ? this.no_days_applied : null;
      this.leaveDialog = true;
    },

    getTypeOfLeaves() {
      this.axiosCall("/types-of-leave", "GET").then((res) => {
        this.type_of_leave_list = res.data;
      });
    },

    closeD() {
      this.eventHub.$emit("closeViewEmployeeLeaveCardDialog", false);
      this.dialog = false;
      this.no_days_applied = null;
      this.tab = 1;
      this.activeTab = this.tabList[1];
      this.credits_to_restore = null;
    },
    closeRestoreDialog() {
      this.restored_selected_type_of_leave = null;
      this.restoredDialog = false;
      this.inclusive_dates = [];
      this.credits_to_restore = null;
      this.inclusive_date_from = null;
      this.inclusive_date_to = null;
      this.remarks = null;
      this.filename = null;
      this.credits_to_restore = null;
    },
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  border-collapse: collapse;
}
table,
td {
  border-bottom: 1px solid rgb(206, 202, 202);
}
tr:first-child th:first-child {
  border-top-left-radius: 10px;
}
tr:first-child th:last-child {
  border-top-right-radius: 10px;
}

tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}
tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

/* tr:nth-child(2) th:first-child {
  border-top-left-radius: none;
}
tr:nth-child(2) th:last-child {
  border-top-right-radius: none;
} */

tr td:first-child {
  border-left: 1px solid rgb(206, 202, 202);
}
tr td:last-child {
  border-right: 1px solid rgb(206, 202, 202);
}
</style>
